import { Avatar, Card, Icon, IconButton, LinearProgress, List, ListItem, ListItemAvatar, ListItemText } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { UserLicenseTypeEnum } from "../../_common/enum/forms/userLicenseType.enum";
import { stringToDateFormatText } from "../../_helpers/format.helper";
import { handleErrorResponse } from "../../_helpers/handleResponse.helper";
import { userLicenseService } from "../../_services/userLicense.service";
import { UserProfileLicenseView } from "../userProfile/userProfile-licenseView";

export function UserProfilePageLicenseList() {

    const { userId } = useParams<{ userId: string }>();

    let navigate = useNavigate();

    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState<any>([]);
    const [showLicense, setShowLicense] = useState<any>(null);

    useEffect(() => {
        fetchData();
    }, []);

    function fetchData() {

        setIsLoading(true)
        return userLicenseService
            .getCurrentUserLicenses(userId || "")
            .then(
                (json) => {
                    if (json && json.length) {
                        json.forEach((d: any) => {
                            d.licenseIsActive = d.statusString == "Active"; //new Date(d.licenseExpirationDate) >= new Date((new Date()).setHours(0, 0, 0, 0));
                            d.licenseExpirationDate = stringToDateFormatText(d.licenseExpirationDate);
                        });
                    }
                    setData(json);

                }, handleErrorResponse
            )
            .finally(() => {
                setIsLoading(false);
            });
    }


    return (
        <>
            <Card sx={{ height: 'auto' }}>
                {isLoading && <LinearProgress />}
                {!isLoading &&
                    <List>
                        {(data && data.length > 0) && data.map((d: any, i: number) =>
                            <span key={"licenseItemTypea_" + i}>
                                {(d.licenseTypeId == UserLicenseTypeEnum.CompetitionLicenceApplication) &&
                                    <ListItem
                                        key={"licenseItemType_" + i}
                                        onClick={() => { setShowLicense(d) }}
                                        secondaryAction={
                                            <>

                                                <IconButton edge="end" aria-label="delete">
                                                    <Icon>visibility</Icon>
                                                </IconButton>
                                            </>
                                        }
                                    >
                                        <ListItemAvatar>
                                            <Avatar>
                                                <Icon>directions_car</Icon>
                                            </Avatar>
                                        </ListItemAvatar>
                                        <ListItemText
                                            primary="Competition Licence"
                                            secondary={<>{d.licenseIsActive ? <i style={{ color: "green" }}>Active: </i> : <i style={{ color: "red" }}>{d.statusString}: </i>} {d.licenseExpirationDate}</>}
                                        />
                                    </ListItem>}


                                {(d.licenseTypeId == UserLicenseTypeEnum.OneDayEvent) &&
                                    <ListItem
                                        key={"licenseItemType_" + i}
                                        onClick={() => { setShowLicense(d) }}
                                        secondaryAction={
                                            <>

                                                <IconButton edge="end" aria-label="delete">
                                                    <Icon>visibility</Icon>
                                                </IconButton>
                                            </>
                                        }
                                    >
                                        <ListItemAvatar>
                                            <Avatar>
                                                <Icon>note</Icon>
                                            </Avatar>
                                        </ListItemAvatar>
                                        <ListItemText
                                            primary="One Day Licence"
                                            secondary={<>{d.licenseIsActive ? <i style={{ color: "green" }}>Active: </i> : <i style={{ color: "red" }}>{d.statusString}: </i>} {d.licenseExpirationDate}</>}
                                        />
                                    </ListItem>}

                                {(d.licenseTypeId == UserLicenseTypeEnum.Media) &&
                                    <ListItem
                                        key={"licenseItemType_" + i}
                                        onClick={() => { setShowLicense(d) }}
                                        secondaryAction={
                                            <>

                                                <IconButton edge="end" aria-label="delete">
                                                    <Icon>visibility</Icon>
                                                </IconButton>
                                            </>
                                        }
                                    >
                                        <ListItemAvatar>
                                            <Avatar>
                                                <Icon>radio</Icon>
                                            </Avatar>
                                        </ListItemAvatar>
                                        <ListItemText
                                            primary="Media Accreditation"
                                            secondary={<>{d.licenseIsActive ? <i style={{ color: "green" }}>Active: </i> : <i style={{ color: "red" }}>{d.statusString}: </i>} {d.licenseExpirationDate}</>}
                                        />
                                    </ListItem>}

                                {(d.licenseTypeId == UserLicenseTypeEnum.Official) &&
                                    <ListItem
                                        key={"licenseItemType_" + i}
                                        onClick={() => { setShowLicense(d) }}
                                        secondaryAction={
                                            <>
                                                <IconButton edge="end" aria-label="delete">
                                                    <Icon>visibility</Icon>
                                                </IconButton>
                                            </>
                                        }
                                    >
                                        <ListItemAvatar>
                                            <Avatar>
                                                <Icon>local_shipping</Icon>
                                            </Avatar>
                                        </ListItemAvatar>
                                        <ListItemText
                                            primary="Official Licence"
                                            secondary={<>{d.licenseIsActive ? <i style={{ color: "green" }}>Active: </i> : <i style={{ color: "red" }}>{d.statusString}: </i>} {d.licenseExpirationDate}</>}
                                        />
                                    </ListItem>}

                                {(d.licenseTypeId == UserLicenseTypeEnum.MinorEntrant) &&
                                    <ListItem
                                        key={"licenseItemType_" + i}
                                        onClick={() => { setShowLicense(d) }}
                                        secondaryAction={
                                            <>
                                                <IconButton edge="end" aria-label="delete">
                                                    <Icon>visibility</Icon>
                                                </IconButton>
                                            </>
                                        }
                                    >
                                        <ListItemAvatar>
                                            <Avatar>
                                                <Icon>escalator_warning</Icon>
                                            </Avatar>
                                        </ListItemAvatar>
                                        <ListItemText
                                            primary="Minor Entrant Licence"
                                            secondary={<>{d.licenseIsActive ? <i style={{ color: "green" }}>Active: </i> : <i style={{ color: "red" }}>Inactive: </i>} {d.licenseExpirationDate}</>}
                                        />
                                    </ListItem>}

                                {(d.licenseTypeId == UserLicenseTypeEnum.Questionnaire) &&
                                    <ListItem
                                        key={"licenseItemType_" + i}
                                        onClick={() => { setShowLicense(d) }}
                                        secondaryAction={
                                            <>
                                                <IconButton edge="end" aria-label="delete">
                                                    <Icon>visibility</Icon>
                                                </IconButton>
                                            </>
                                        }>
                                        <ListItemAvatar>
                                            <Avatar>
                                                <Icon>work</Icon>
                                            </Avatar>
                                        </ListItemAvatar>
                                        <ListItemText
                                            primary={d.licenseName + " Licence"}
                                            secondary={<>{d.licenseIsActive ? <i style={{ color: "green" }}>Active: </i> : <i style={{ color: "red" }}>Inactive: </i>} {d.licenseExpirationDate}</>}
                                        />
                                    </ListItem>}
                            </span>
                        )}

                        {(!data || !data.length) &&
                            <ListItem>
                                <ListItemAvatar>
                                    <Avatar>
                                        <Icon>priority_hight</Icon>
                                    </Avatar>
                                </ListItemAvatar>
                                <ListItemText
                                    primary="No Licences found" />
                            </ListItem>
                        }
                    </List>
                }
            </Card>

            {(showLicense) &&
                <UserProfileLicenseView
                    token={showLicense.token}
                    onClose={() => { setShowLicense(null) }} />
            }

        </>
    );

}
